import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { StructuredDataModule } from '@core/structured-data';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GenericModalModule } from '@innogy/common-ui-modals';
import { CommonUiServiceComponentsStoreModule } from '@innogy/common-ui/service-components/store';
import { PaginationComponent } from '@innogy/pagination';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  NgbAccordionModule,
  NgbCarouselModule,
  NgbCollapseModule,
} from '@ng-bootstrap/ng-bootstrap';
import { PartialAccordionTitleComponent } from '@legacy/common-ui-partials';
import { ScIconPipe } from '@core/jss-utils';

import { AvailabilityContainerComponent } from './availability/availability-container.component';
import { FaqContainerComponent } from './faq/faq-container/faq-container.component';
import { FaqComponent } from './faq/faq.component';
import { QuickFeedbackComponent } from './faq/quick-feedback/quick-feedback.component';
import { HowToQuestionnaireContainerComponent } from './how-to-questionnaire-container/how-to-questionnaire-container.component';
import { HowToQuestionnaireOptionComponent } from './how-to-questionnaire-container/how-to-questionnaire-option/how-to-questionnaire-option.component';
import { HowToQuestionnaireQuestionComponent } from './how-to-questionnaire-container/how-to-questionnaire-question/how-to-questionnaire-question.component';
import { HowToReadBillContainerComponent } from './how-to-read-bill/how-to-read-bill-container/how-to-read-bill-container.component';
import { TaxonomyAccordionComponent } from './taxonomy/taxonomy-accordion/taxonomy-accordion.component';
import { TaxonomyContainerComponent } from './taxonomy/taxonomy-container.component';
import { TopTasksContainerComponent } from './top-tasks/top-tasks-container/top-tasks-container.component';

const exportedComponents = [
  HowToQuestionnaireContainerComponent,
  FaqContainerComponent,
  QuickFeedbackComponent,
  TaxonomyContainerComponent,
  AvailabilityContainerComponent,
  TopTasksContainerComponent,
  HowToReadBillContainerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    CommonUiUtilityComponentsModule,
    AnalyticsDirectivesModule,
    CommonUiServiceComponentsStoreModule,
    NgbCollapseModule,
    NgbAccordionModule,
    CoreJssProxyModule,
    NgbCarouselModule,
    GenericModalModule,
    StructuredDataModule,
    PaginationComponent,
    PartialAccordionTitleComponent,
    ScIconPipe,
    ...exportedComponents,
    HowToQuestionnaireQuestionComponent,
    HowToQuestionnaireOptionComponent,
    TaxonomyAccordionComponent,
    FaqComponent,
  ],
  exports: [...exportedComponents],
})
export class CommonUiServiceComponentsModule {}
